<ng-template #rt let-r="result" let-t="term">
  {{ r.name }}
</ng-template>
<div id="irlSearchForm1" class="irl-search-form">
  <p class="tab_icons">
    <app-light-toggle-group tabindex="-1">
      <app-light-toggle-btn
        #onewayBtn
        [selected]="searchParams.journeyType === IrlJourneyType.SingleJourney"
        (click)="searchParams.journeyType = IrlJourneyType.SingleJourney"
        iconClass="ico-oneway"
        tabindex="-1"
        i18n="@@irlSearchTravellingOneWay"
        >One way</app-light-toggle-btn
      >
      <app-light-toggle-btn
        #returnBtn
        [selected]="searchParams.journeyType === IrlJourneyType.ReturnJourney"
        (click)="searchParams.journeyType = IrlJourneyType.ReturnJourney"
        iconClass="ico-return"
        tabindex="-1"
        i18n="@@irlSearchTravellingReturn"
        >Return</app-light-toggle-btn
      >
    </app-light-toggle-group>
    <!--! offline  -->
    <button
      type="checkbox"
      id="offline"
      name="offline"
      (click)="searchParams.offlineRequest = !searchParams.offlineRequest"
      class="offline_button"
      [ngClass]="{
        selected_offline: searchParams.offlineRequest,
        offline: !searchParams.offlineRequest
      }"
    >
      <a for="offline" i18n="@@irlSearchTravellingOffline">Offline requests</a>
    </button>
  </p>
  <div class="inputs-container">
    @if (searchParams.offlineRequest) {
      <div i18n="@@irlSearchTravellingOfflineMessage">
        Please fill out this form if the journey you wish to book is not available online. When you
        submit the request a member of the CTM team will be in touch with a quote. Please call the
        CTM team if your request is for travel within 48 hours.
        <br />
        Please note – for any irl pass requests please contact your offline team
      </div>
    }
    <div class="half-container">
      <div class="half-block">
        <label
          id="irl-travelling-from"
          class="header-label"
          for="travelFrom1"
          i18n="@@irlSearchTravellingFrom"
          >From</label
        >
        <i class="ico-rail combo-box-icon"></i>
        <div class="flex-row-container">
          <input
            #tf
            autocomplete="off"
            type="text"
            id="travelFrom1"
            i18n-placeholder
            placeholder="Enter a station"
            (click)="tf.select()"
            appInput
            name="travellingFrom"
            [ngbTypeahead]="irlLocations"
            [(ngModel)]="searchParams.travellingFrom"
            [resultTemplate]="rt"
            [inputFormatter]="formatter"
            aria-labelledby="irl-travelling-from"
            tabindex="0"
            (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
            (keyup.arrowup)="ensureElementIsScrolledTo($event)"
            [hasError]="searchParams.validationMessages?.includes('Please Enter a From Location.')"
          />
        </div>
      </div>
      <div class="half-block">
        <label
          id="irl-travelling-to"
          class="header-label"
          for="travelFrom2"
          i18n="@@irlSearchTravellngTo"
          >To</label
        >
        <i class="ico-rail combo-box-icon"></i>
        <div class="flex-row-container">
          <input
            #tt
            autocomplete="off"
            type="text"
            id="travelFrom2"
            i18n-placeholder
            placeholder="Enter a station"
            (click)="tt.select()"
            appInput
            name="travellingTo"
            [ngbTypeahead]="irlLocations2"
            [(ngModel)]="searchParams.travellingTo"
            [resultTemplate]="rt"
            [inputFormatter]="formatter"
            aria-labelledby="irl-travelling-to"
            tabindex="0"
            (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
            (keyup.arrowup)="ensureElementIsScrolledTo($event)"
            [hasError]="searchParams.validationMessages?.includes('Please Enter a To Location.')"
          />
        </div>
      </div>
    </div>
    <div class="half-container">
      <div class="half-block">
        <div
          class="flex-row-container clearfix"
          [ngClass]="{
            'error-box': searchParams.validationMessages?.includes(
              'Departure Date/Time cannot be in the past.'
            )
          }"
        >
          <ngbd-datepicker-i18n>
            <div class="flex-column-container combo-box-left">
              <label
                class="header-label date-label"
                for="irl-outbound-date"
                i18n="@@irlSearchOutboundDate"
                >Outbound date (DD/MM/YYYY)</label
              >
              <i class="ico-calendar combo-box-icon cursor_pointer"></i>
              <app-datepicker
                [minDate]="searchParams.minOutboundDate"
                [startDate]="searchParams.outbound_date"
                [model]="searchParams.outbound_date"
                [from]="
                  searchParams.journeyType === IrlJourneyType.ReturnJourney
                    ? searchParams.outbound_date
                    : null
                "
                [to]="
                  searchParams.journeyType === IrlJourneyType.ReturnJourney
                    ? searchParams.return_date
                    : null
                "
                (newFrom)="searchParams.outbound_date = $event"
                (newTo)="searchParams.return_date = $event"
                [class]="'combo-box'"
                [componentId]="'irl-outbound-date'"
                (newDate)="searchParams.outbound_date = $event"
              >
              </app-datepicker>
            </div>
            <div class="flex-column-container combo-box-right">
              <label class="header-label" for="irl-outbound-time" i18n="@@irlSearchOutboundTime"
                >Outbound time</label
              >
              <i class="ico-clock combo-box-icon"></i>
              <select
                class="combo-box"
                id="irl-outbound-time"
                [(ngModel)]="searchParams.outbound_time"
              >
                @for (time of searchParams.timeArray ?? []; track time) {
                  <option [ngValue]="time.value">{{ time.display }}</option>
                }
              </select>
            </div>
          </ngbd-datepicker-i18n>
        </div>
      </div>
      <div
        class="half-block irl_return_container"
        [ngClass]="{
          irl_return_disabled: searchParams.journeyType === IrlJourneyType.SingleJourney
        }"
      >
        <div class="flex-row-container clearfix">
          <ngbd-datepicker-i18n>
            <div class="flex-column-container combo-box-left">
              <label
                class="header-label date-label"
                for="irl-return-date"
                id="returndateandtime"
                i18n="@@irlSearchReturnDate"
                >Return date (DD/MM/YYYY)</label
              >
              <i class="ico-calendar combo-box-icon cursor_pointer"></i>
              <app-datepicker
                [minDate]="searchParams.minOutboundDate"
                [startDate]="searchParams.return_date || searchParams.minInboundDate"
                [model]="searchParams.return_date"
                [from]="
                  searchParams.journeyType === IrlJourneyType.ReturnJourney
                    ? searchParams.outbound_date
                    : null
                "
                [to]="
                  searchParams.journeyType === IrlJourneyType.ReturnJourney
                    ? searchParams.return_date
                    : null
                "
                (newFrom)="searchParams.outbound_date = $event"
                (newTo)="searchParams.return_date = $event"
                [class]="'combo-box'"
                [componentId]="'irl-return-date'"
                [disabled]="!(searchParams.journeyType === IrlJourneyType.ReturnJourney)"
                (newDate)="searchParams.return_date = $event"
              >
              </app-datepicker>
            </div>
            <div class="flex-column-container select-box-right">
              <i class="ico-clock select-box-icon"></i>
              <label class="header-label" i18n="@@AriaIrlReturnDate" for="irl_return_time"
                >Return time</label
              >
              <select
                appSelect
                id="irl_return_time"
                [disabled]="!(searchParams.journeyType === IrlJourneyType.ReturnJourney)"
                [(ngModel)]="searchParams.return_time"
              >
                @for (time of searchParams.timeArray ?? []; track time) {
                  <option [ngValue]="time.value">{{ time.display }}</option>
                }
              </select>
            </div>
          </ngbd-datepicker-i18n>
        </div>
      </div>
    </div>
    <div class="flex-column-container">
      @if (!searchParams.offlineRequest) {
        <div>
          <h2 class="header-label rem-1-5" i18n="@@irlSearchOptions">Options</h2>
          <div class="quarter-container">
            <div class="quarter-block">
              <label id="irl-service-class" i18n="@@IrlSearchMaxClass" for="irl_class">Class</label>
              <select
                class="combo-box"
                [(ngModel)]="searchParams.irlClass"
                aria-labelledby="irl-service-class"
                id="irl_class"
              >
                @for (serviceClass of searchParams.classTypes; track serviceClass) {
                  <option value="{{ serviceClass.value }}">
                    {{ serviceClass.display | translate }}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
      }
      <div class="traveller_information_container">
        <label class="container_label">
          <h3 i18n="@@irlSearchTravellerInformation">Traveller information</h3>
        </label>
        @if (travellers.length === 0) {
          <p i18n="@@irlSearchNoTravellers">No travellers selected</p>
        }
        @for (traveller of travellers; track traveller; let i = $index; let first = $first) {
          <div class="traveller_select_container quarter-container">
            <div class="traveller_info quarter-block">
              <label class="container_label" i18n="@@irlSearchName" for="traveller_name"
                >Name</label
              >
              <input
                name="name{{ i }}"
                id="tickets{{ traveller.forename }} {{ traveller.surname }}"
                readonly
                value="{{ traveller.forename }} {{ traveller.surname }}"
              />
            </div>
            <div class="traveller_info quarter-block">
              <label class="container_label" i18n="@@irlSearchAgeRange" for="traveller_name"
                >Age range
                <section (mouseleave)="tt1.close()" class="container">
                  <i
                    class="ico ico-info-circle"
                    placement="top"
                    i18n-ngbTooltip
                    triggers="manual"
                    #tt1="ngbTooltip"
                    (mouseenter)="tt1.open()"
                    (focus)="tt1.open()"
                    (blur)="tt1.close()"
                    tabindex="0"
                    [ngbTooltip]="travellerTooltip"
                  >
                  </i>
                </section>
              </label>
              <select
                name="age_type_select_{{ i }}"
                id="tickets{{ traveller.name }}"
                [(ngModel)]="travellers[i].ageType"
                required
              >
                @for (age of searchParams.ageRanges; track age) {
                  <option [value]="age.key">{{ age.value }}</option>
                }
              </select>
            </div>
            <!-- ! discount cards and loyalty cards -->
            @if (searchParams.irlDiscountCardsArray.length) {
              <div class="traveller_info quarter-block">
                <label class="container_label" i18n="@@irlSearchDiscountCard" for="traveller_name"
                  >Discount card
                </label>
                <select
                  name="discount_card_select_{{ i }}"
                  id="tickets{{ traveller.name }}"
                  [(ngModel)]="selectedDiscountCards[i]"
                  (change)="changeIrlcardOption()"
                  [compareWith]="cardComparator"
                >
                  <option [value]="undefined" i18n="@@discountCardProvider">(None)</option>
                  @for (card of searchParams.irlDiscountCardsArray; track card) {
                    <option [ngValue]="card">{{ card.name }}</option>
                  }
                </select>
              </div>
            }
          </div>
        }
        <!-- !offline -->
        @if (searchParams.offlineRequest) {
          <div class="additional_info_container">
            <div class="half-container offline_info_boxes">
              <div class="">
                <label class="container_label">
                  <h3 i18n="@@IrlSearchAdditionalInformation">Additional information</h3>
                </label>
                <div class="traveller_info quarter-block">
                  <div class="quarter-block offline_info_boxes">
                    <label id="irl-service-class" i18n="@@IrlSearchTrainNumber" for="irl_class"
                      >Train number
                    </label>
                    <input [(ngModel)]="searchParams.trainNumber" class="combo-box" />
                  </div>
                </div>
                <div class="traveller_info quarter-block">
                  <div class="quarter-block">
                    <label id="irl-service-class" i18n="@@IrlSearchMaxClass" for="irl_class"
                      >Class</label
                    >
                    <select
                      class="combo-box"
                      [(ngModel)]="searchParams.irlClass"
                      aria-labelledby="irl-service-class"
                      id="irl_class"
                    >
                      @for (serviceClass of searchParams.classTypes; track serviceClass) {
                        <option value="{{ serviceClass.value }}">
                          {{ serviceClass.display | translate }}
                        </option>
                      }
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="half-block addition_instructions_container">
              <label id="irl-service-class" i18n="@@IrlSearchInstructions" for="irl_class"
                >Additional instructions</label
              >
              <textarea
                [(ngModel)]="searchParams.additionalInstructions"
                class="addition_instructions"
              >
Notes</textarea>
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <ng-template #travellerTooltip>
    <table style="width: 500px; text-align: left">
      <tr>
        <th>Country</th>
        <th>Child</th>
        <th>Youth</th>
        <th>Senior</th>
      </tr>
      <tr>
        <td>Eurostar</td>
        <td>4-11y</td>
        <td>12-25y</td>
        <td></td>
      </tr>
      <tr>
        <td>Austria</td>
        <td>6-15y</td>
        <td>16-25y</td>
        <td></td>
      </tr>
      <tr>
        <td>Belgium</td>
        <td>6-15y</td>
        <td>16-25y</td>
        <td></td>
      </tr>
      <tr>
        <td>Bosnia</td>
        <td>4-11y</td>
        <td>12-25y</td>
        <td></td>
      </tr>
      <tr>
        <td>Bulgaria</td>
        <td>6-15y</td>
        <td>16-25y</td>
        <td></td>
      </tr>
      <tr>
        <td>Croatia</td>
        <td>4-11y</td>
        <td>12-25y</td>
        <td></td>
      </tr>
      <tr>
        <td>Denmark</td>
        <td>6-15y</td>
        <td>16-25y</td>
        <td></td>
      </tr>
      <tr>
        <td>Finland</td>
        <td>6-16y</td>
        <td>17-25y</td>
        <td></td>
      </tr>
      <tr>
        <td>France</td>
        <td>4-11y</td>
        <td>12-25y</td>
        <td></td>
      </tr>
      <tr>
        <td>Germany</td>
        <td>6-14y</td>
        <td>15-25y</td>
        <td></td>
      </tr>
      <tr>
        <td>Greece</td>
        <td>4-11y</td>
        <td>12-25y</td>
        <td></td>
      </tr>
      <tr>
        <td>Hungary</td>
        <td>6-13y</td>
        <td>14-25y</td>
        <td></td>
      </tr>
      <tr>
        <td>Italy</td>
        <td>4-11y</td>
        <td>12-25y</td>
        <td></td>
      </tr>
      <tr>
        <td>Luxemburg</td>
        <td>6-11y</td>
        <td>12-25y</td>
        <td></td>
      </tr>
      <tr>
        <td>Macedonia</td>
        <td>4-11y</td>
        <td>12-25y</td>
        <td></td>
      </tr>
      <tr>
        <td>Netherlands</td>
        <td>4-11y</td>
        <td>12-25y</td>
        <td></td>
      </tr>
      <tr>
        <td>Poland</td>
        <td>4-11y</td>
        <td>12-25y</td>
        <td></td>
      </tr>
      <tr>
        <td>Portugal</td>
        <td>4-11y</td>
        <td>12-25y</td>
        <td></td>
      </tr>
      <tr>
        <td>Romania</td>
        <td>4-11y</td>
        <td>12-25y</td>
        <td></td>
      </tr>
      <tr>
        <td>Serbia</td>
        <td>4-11y</td>
        <td>12-25y</td>
        <td></td>
      </tr>
      <tr>
        <td>Slovakia</td>
        <td>6-11y</td>
        <td>12-25y</td>
        <td></td>
      </tr>
      <tr>
        <td>Slovenia</td>
        <td>6-11y</td>
        <td>12-25y</td>
        <td></td>
      </tr>
      <tr>
        <td>Spain</td>
        <td>4-13y</td>
        <td>14-25y</td>
        <td></td>
      </tr>
      <tr>
        <td>Switzerland</td>
        <td>6-15y</td>
        <td>16-25y</td>
        <td></td>
      </tr>
      <tr>
        <td>UK</td>
        <td>6-16y</td>
        <td>17-25y</td>
        <td></td>
      </tr>
      <tr>
        <td>Australia</td>
        <td>4-15y</td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>New Zealand</td>
        <td>2-14y</td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>USA</td>
        <td>2-12y</td>
        <td></td>
        <td>62+</td>
      </tr>
      <tr>
        <td>Canada</td>
        <td>2-11y</td>
        <td></td>
        <td>60+</td>
      </tr>
    </table>
  </ng-template>
  <app-irl-loading-screen></app-irl-loading-screen>
</div>
